module.exports = __webpack_public_path__ + "img/u31.aac05c7e.jpg";